import classNames from 'classnames';
import Icon from '@/components/atoms/icon/icon';
import Typography from '@/components/atoms/typography/typography';
import styles from './alert-pill.module.scss';

export interface AlertPillProps {
  /** The class name to apply */
  className?: string;
  /** The size of the alert pill */
  size?: 'large' | 'small';
  /** The rich text to show */
  text?: string;
  /** The variant of the alert pill */
  variant?: 'default' | 'pending' | 'success' | 'danger';
}

const AlertPill = ({
  className,
  text,
  variant = 'default',
  size = 'large',
}: AlertPillProps) => {
  return (
    <div
      className={classNames(styles.component, className, {
        [styles.isPending]: variant === 'pending',
        [styles.isSuccess]: variant === 'success',
        [styles.isDanger]: variant === 'danger',
        [styles.isSmall]: size === 'small',
      })}
    >
      <div className={styles.iconContainer}>
        <Icon name="CheckMark" size={8} />
      </div>

      <Typography tagStyle="bodyMediumBold">{text}</Typography>
    </div>
  );
};

AlertPill.displayName = 'AlertPill';

export default AlertPill;
